import { IGetMapaConcretagemByIdUseCase } from "../../../presentation/useCases/read/get_mapa_concretagem_by_id_use_case";
import { MapaConcretagemDetalhes } from "../../models/mapa_concretagem";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * GetMapaConcretagemByIdUseCase
 */

export class GetMapaConcretagemByIdUseCase implements IGetMapaConcretagemByIdUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async getMapaConcretagemById(
    idMapaConcretagem: number | undefined,
  ): Promise<MapaConcretagemDetalhes> {
    if (idMapaConcretagem === undefined) throw new Error("Falha ao obter id do mapa de concretagem!");
    const response = await this.repository.getMapaConcretagemById(idMapaConcretagem);
    if (response == null) throw new Error('Falha ao buscar mapa de concretagem');
    return response;
  }
}
